webpackJsonp([22],{

/***/ 1965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_leiloes_services_lote_entidade__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'novo-tipo-lote-entidade',
  data: function data() {
    return {
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        nome: null
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    this.isLoaded = true;
  },
  activated: function activated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    submit: function submit() {
      var _this = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$loaderOverlay.open().message('Processando...');
      this.$bar.start();
      window.setTimeout(function () {
        _this.$loaderOverlay.message('Aguarde...');
      }, 1000);
      __WEBPACK_IMPORTED_MODULE_0__domain_leiloes_services_lote_entidade__["a" /* default */].cadastrarTipoEntidade(this.data).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this.$bar.finish();
          _this.$loaderOverlay.hide();

          _this.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this.$bar.finish();
        _this.$loaderOverlay.hide();
        _this.cadastroError = response.data.errors;
        _this.$nextTick(function () {
          _this.$refs.error.focus();
        });
        console.log(response);
      });
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    }
  }
});

/***/ }),

/***/ 1997:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1965),
  /* template */
  __webpack_require__(2013),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2013:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Tipo de Entidade Lote")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.94887798803e1a8104bd.js